export const THEME_MODE_STORAGE_KEY = "mui-mode"
export const THEME_COLOR_SCHEME_STORAGE_KEY = "mui-color-scheme"
export const DEFAULT_THEME_MODE = "light"

/** Default when no preference is stored; must be a key in PREFERENCE_TO_MUI_SCHEME. */
export const DEFAULT_THEME_PREFERENCE = "light-colors"

export const THEME_PREFERENCE_KEY = "themeMode"
export const THEME_PREFERENCE_TYPE = "ui"

export const APP_COLOR_SCHEME_ATTRIBUTE = "data-mui-color-scheme"

export const PREFERENCE_TO_MUI_SCHEME = {
  "light-colors": "light",
  "dark-colors": "dark",
  system: "system",
}

export const VALID_THEME_PREFERENCES = Object.keys(PREFERENCE_TO_MUI_SCHEME)

export function applyMuiSchemeFromPreference(preference, { setMode, setColorScheme }) {
  const muiScheme = PREFERENCE_TO_MUI_SCHEME[preference]
  if (muiScheme !== "light" && muiScheme !== "dark" && muiScheme !== "system") {
    return
  }
  setMode(muiScheme)
  if (!setColorScheme) {
    return
  }
  if (muiScheme === "light") {
    setColorScheme({ light: "light" })
  } else if (muiScheme === "dark") {
    setColorScheme({ dark: "dark" })
  } else {
    setColorScheme({ light: "light", dark: "dark" })
  }
}
